// extracted by mini-css-extract-plugin
module.exports = {"navColor":"header_navColor__3ZUtl","navLink":"header_navLink__1gXZR","isActive":"header_isActive__31N_X","navBrand":"header_navBrand__1JcGs","navbar":"header_navbar__3Uska"};